/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */
import { isObject } from "lodash";
import _ = require("lodash");

const del = (d) => {
  Object.keys(d).forEach((key) => {
    if (isObject(d[key])) del(d[key]);
    if (d[key] === "" || d[key] == null || Number.isNaN(d[key])) {
      delete d[key];
    }
  });
};

export const deleteUnacceptableKeys = (data) => {
  const ret = _.cloneDeep(data);
  del(ret);

  return ret;
};
